import { useGetCashFlowTotalQuery } from 'bus/cash';
import React, { FC, useMemo } from 'react';


const CashTotal: FC = () => {
  const { data } = useGetCashFlowTotalQuery(undefined, { refetchOnMountOrArgChange: true });
  const colorIsRed = (sum: number) => sum < 0;

  const totalSum = useMemo(() => {
    return data?.reduce((total, item) => total + item.sum, 0)
  }, [data]);

  return (
    <div
      className="d-flex justify-end mb-2"
    >
      <div
        className="dx-card d-flex justify-end pa-2"
      >
        <div
          className="ml-2 mr-2"
          style={{
            fontSize: 14,
            borderBottom: '1px solid #7e7e7e',
            color: colorIsRed(Number(totalSum)) ? 'red' : 'black'
          }}
        >
          <b>Остаток: </b> { totalSum?.toLocaleString('ru', { minimumFractionDigits: 2 }) }
        </div>
        <div style={{ borderRight: '1px dashed #000' }}></div>
        {
          data?.map(item => (
            <div key={item.cashFlowAccount} className="ml-2" style={{ fontSize: 14, color: colorIsRed(item.sum) ? 'red' : 'black' }}>
              <b>{ item.name }: </b> { item.sum.toLocaleString('ru', { minimumFractionDigits: 2 }) }
            </div>
          ))
      }
      </div>
    </div>
  );
};

export default CashTotal;
